<div class="p-4">
	<div class="demo-container">
    	<div class="title">Recovery Assets Interest Generator</div>
    	<button
			type="button"
			class="btn btn-primary btn-sm"
			(click)="runRecoveryAssetInterestGeneration()"
			*ngIf="!isRunningRecoveryAssetData" data-testid="recovery-assets-generate-interest-for-all">
			Generate interest for all recovery assets
		</button>

		<div class="" role="status" *ngIf="isRunningRecoveryAssetData">
			Running recovery assets data
			<i class="fa-solid fa-period"></i>
			<i class="fa-solid fa-period"></i>
			<i class="fa-regular fa-period fa-fade"></i><br />
			<div class="text-primary m-1">
				<i class="fa-solid fa-ghost fa-beat-fade fa-3x"></i>
			</div>
		</div>
	</div>
</div>


// WEBPACK FOOTER //
// ./src/app/developer/components/developer-tools/recovery-assets/recovery-assets.component.html